/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { DictionaryItem, EnumDictionary } from '@gh/common-shared';
import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { includes } from 'lodash';

import { CostCenterAutocompleteListItemDto } from '../cost-centers';
import { EmailTemplateAutocompleteListItemDto } from '../email-templates';
import { UserSystemRole } from '../users';

export type MilestoneEventListItemDto = WithVersion<{
  milestoneEventId: ID;
  eventDate: string;
  eventDateValue: MilestoneEventType;
  sendMethod: string;
  sendMethodValue: MilestoneSendMethodType;
  sendFrom: string;
  sendFromValue: MilestoneEventFromToType;
  sendTo: string;
  sendToValue: MilestoneEventFromToType;
  noOfDays: string;
  templateDesc: string;
}>;

export type MilestoneEventDetailsDto = WithVersion<{
  milestoneEventId?: ID;
  eventDate?: MilestoneEventType;
  costCenter?: CostCenterAutocompleteListItemDto;
  sendMethod: MilestoneSendMethodType;
  template?: EmailTemplateAutocompleteListItemDto;
  sendWhen: MilestoneEventFiresType;
  numberOfDays?: number;
  sendFrom?: MilestoneEventFromToType;
  sendFromSystemRole?: UserSystemRole;
  sendTo?: MilestoneEventFromToType;
  sendToSystemRole?: UserSystemRole;
}>;

export const MilestoneSendMethodType = createEnum('MILESTONE_EVENT_METHOD', {
  Email: 1,
  Sms: 2,
});
export type MilestoneSendMethodType = EnumSet<typeof MilestoneSendMethodType>;

export const MilestoneEventFromToType = createEnum('MILESTONE_EVENT_FROM_TO', {
  IndSystemRole: 1,
  GroupSystemRole: 2,
  Customer: 3,
  Supplier: 4,
});
export type MilestoneEventFromToType = EnumSet<typeof MilestoneEventFromToType>;

export const filterSendFromToEnumDictionary = (fromToList: MilestoneEventFromToType[]) =>
  (dictionary: EnumDictionary<MilestoneEventFromToType>) =>
    dictionary.filter(({ id: type }: DictionaryItem<any>) => includes(fromToList, type));

export const MilestoneEventFiresType = createEnum('MILESTONE_EVENT_FIRES', {
  SameDay: 1,
  After: 2,
  Before: 3,
});
export type MilestoneEventFiresType = EnumSet<typeof MilestoneEventFiresType>;

export const MilestoneEventType = createEnum('MILESTONE_EVENTS', {
  SubcontractorAgreementExpiryDate: 1,
  SubcontractorInsuranceExpiryDate: 2,
  SubcontractorLicenseExpiryDate: 3,
  PriceBookWithdrawalDate: 4,
  SalesFollowUpDate: 5,
  SalesFolderCreatedDate: 6,
  LastCommunicationForLead: 7,
  QuotePrintedDate: 8,
  QuoteApprovedDate: 9,
  AuthorityToProceedDate: 10,
  SaleCompletedDate: 11,
  DepositDate: 12,
  SaleDate: 13,
  ContractSignedDate: 14,
  ColorSelectionDateFirstSentForSigning: 15,
  ColorSelectionDateSignedByClient: 16,
  ColorSelectionDateSignedByOffice: 17,
  FinanceApprovedDate: 18,
  CountyApprovalDate: 19,
  AuthorityToCommenceDate: 20,
  JobEstimateAuthorizedDate: 21,
  ContractStartDate: 22,
  ContractCompletionDate: 23,
  SlabDate: 24,
  InitialConstDrawDate: 25,
  CompletedDate: 26,
  HandoverDate: 27,
  FinalizedDate: 28,
  FinalDrawDate: 29,
  ChangeOrderIssueDate: 30,
  ChangeOrderApprovedDate: 31,
  ChangeOrderRejectedDate: 32,
  SupervisorScheduleActivityStartDate: 33,
  SupervisorScheduleActivityEndDate: 34,
});
export type MilestoneEventType = EnumSet<typeof MilestoneEventType>;
